import React, { useEffect, useMemo, useState } from "react"
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import "./index.scss"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import header_logo from "../../images/Header_logo_1.png";
import { Backdrop, Badge, Button, CircularProgress, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import Config from "../../Utils/Config";
import { resolveMarketUrl } from "../../Utils/districtStore";
import information from "../../images/Icon/information.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { PostCallApi } from "../../Action/Action";
import { SwalError, SwalMessage } from "../../components/SwalToast";
import { persistor } from "../../store";
import pro_img from "../../images/default_profile.jpg";
import { useSignalR } from "../../Utils/SignalRContext";
import axios from "axios";
import { FaAngleRight } from "react-icons/fa6";
import { IoIosArrowUp } from "react-icons/io";
import { ReportName, SettingName, SettingNameUrl } from "../../reducers/setting";
import { CreteDataFor } from "../../reducers/user";
import { includes } from "lodash";
import useSettingsNav from "../../Modules/User/Settings/hooks/useSettingsNav";

const user_mennul = "/assets/user_mennul.svg";
const SidebarMenu = ({ isOpen, setIsOpen, setIsSidebarChatOpen }) => {
    const [openCircle, setOpenCircle] = useState(false);
    const location = useLocation();
    const [pathname, setPathname] = useState();
    let dispatch = useDispatch();
    let nav = useNavigate();
    const LoginId = useSelector((state) => state.login.LoginDetails);
    let TopMenuList = useSelector((state) => state?.setting?.TopMenuList || []);
    let LoginUserd = useSelector((state) => state.login?.LoginDetails);
    const token = useSelector((state) => state.login.LoginDetails.accessToken);
    // MenuList is read through useSettingsNav below rather than directly.
    const ReportList = useSelector((state) => state.setting?.ReportList);

    // Fallback nav for the State Agency feature until the DB menu rows propagate.
    // Sidebar is otherwise fully menu-driven; inject the new items for the roles
    // that can use them (Super Admin 1, State Agency 14), avoiding duplicates.
    const saRoleId = LoginUserd?.roleId;
    const extraSidebarMenus = [];
    if ((saRoleId === 1 || saRoleId === 14) && !TopMenuList?.some((m) => m.menuUrl === "/state-dashboard"))
        extraSidebarMenus.push({ menuName: "Portfolio Management", menuUrl: "/state-dashboard" });
    if (saRoleId === 1 && !TopMenuList?.some((m) => m.menuUrl === "/allocation-groups"))
        extraSidebarMenus.push({ menuName: "Portfolio Accounts", menuUrl: "/allocation-groups" });
    const sidebarMenus = [...(TopMenuList || []), ...extraSidebarMenus];

    // Same taxonomy the settings hub and top bar use, reshaped into the {menuName, subMenu}
    // form renderSubMenu already understands. Purely a regrouping of MenuList -- it cannot
    // surface an item the access API did not return.
    const { groups: settingsGroups } = useSettingsNav();
    const settingsSubMenu = useMemo(
        () =>
            settingsGroups.map((group) => ({
                menuName: group.name,
                subMenu: group.items.map((item) => ({
                    menuName: item.menuName,
                    displayName: item.label,
                    menuUrl: item.menuUrl,
                    menuType: "SettingsInnerMenu",
                })),
            })),
        [settingsGroups]
    );


    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
    };
    useEffect(() => {
        setPathname(location?.pathname);
        // eslint-disable-next-line
    }, [location]);

    // For Toggle Dashboard

    const [isModern, setIsModern] = useState(() => JSON.parse(localStorage.getItem("default_dashboard_type")) || false);
    const toggleDashboard = () => {
        const newType = !isModern;
        localStorage.setItem("default_dashboard_type", JSON.stringify(newType));
        // Remember the user's own choice so it survives the next login (district value is only a default).
        localStorage.setItem("dashboard_user_choice", "1");
        window.dispatchEvent(new Event("storage"));
        setIsModern(newType);
    };

    const handleNav = async (redirect) => {
        setOpenCircle(true);
        let apiBody = {
            createdBy: LoginId?.userId,
            logOutName: LoginId?.firstName + " " + LoginId?.lastName,
            email: LoginId?.email,
            type: "Web",
        };

        let sendData = {
            url: `/api/Common/SaveUserActivityLogOut`,
            body: apiBody,
        };

        let resp = await PostCallApi(sendData);
        setOpenCircle(false);
        if (resp?.status === 200 && resp?.data?.success) {
            localStorage.clear("expireDate");
            nav(redirect ? redirect : "/", { replace: true });
            setTimeout(() => {
                dispatch({ type: "LOGOUT" });
                persistor.purge();
            }, 0);
        } else {
            SwalError(resp?.data?.message);
        }
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openNotification = Boolean(anchorEl);
    const [notificationList, setNotificationList] = useState([]);
    const [readNotification, setReadNotification] = useState(false);
    const { connection } = useSignalR();
    const handleClick = (event) => {
        if (notificationList?.length > 0) {
            setAnchorEl(event?.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        getNotification();
        const interval = setInterval(() => getNotification(), 60000);
        return () => {
            clearInterval(interval);
        };
        // eslint-disable-next-line
    }, [readNotification]);

    useEffect(() => {
        if (connection && LoginId?.userId) {
            connection?.on("MenuUpdateOnlineUser", (data) => {
                handleMessage(data);
            });
        }
        // eslint-disable-next-line
    }, [connection]);
    const handleMessage = async (data) => {
        let rv = await SwalMessage(data);
        if (rv?.isConfirmed) handleNav("/login");
    };

    const getNotification = () => {
        axios
            .get(
                `${Config.API_HOST_URL_live}/api/Common/GetNotificationByUserId?userId=${LoginUserd.userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "*/*",
                    },
                }
            )
            .then((response) => {
                if (response.data.success) {
                    let notificationData = response.data.payload?.map((notify, i) => {
                        // if (notify.isRead === false) {
                        return {
                            isRead: notify.isRead,
                            notificationId: notify?.notificationId,
                            notificationText: notify?.notificationText,
                            userId: notify.user?.userId,
                            user: notify.user?.firstName + " " + notify.user?.lastName,
                            imgUser:
                                notify?.user?.profileUrl === undefined ||
                                    notify?.user?.profileUrl === "" ||
                                    notify?.user?.profileUrl === null
                                    ? pro_img
                                    : `${Config.API_HOST_URL_live}${notify?.user?.profileUrl}`,
                            notificationType: notify?.notificationType,
                            createdOn: notify?.createdOn,
                            createdBy: notify?.createdBy,
                            linkUrl: notify?.linkUrl,
                        };
                        // }
                        // return 0;
                    });
                    notificationData = notificationData.filter(function (element) {
                        return element !== undefined;
                    });
                    notificationData = notificationData.filter(function (element) {
                        return element !== 0;
                    });
                    setNotificationList(notificationData);
                } else {
                    setNotificationList([]);
                }
            });
    };
    const HandleNotificationRedirect = (e) => {
        axios
            .post(
                `${Config.API_HOST_URL_live}/api/Common/UpdateNotification?notificationId=${e.notificationId}`,
                {},
                { headers }
            )
            .then((response) => {
                if (response.data.success) {
                    setReadNotification(!readNotification);
                }
            });
        if (e?.notificationType === "message" || e?.notificationType === "chat") {
            nav("/messages", { replace: true });
        } else if (e?.notificationType === "userprofile") {
            nav(`/edit-profile`, { replace: true });
        } else if (e?.notificationType === "sentrequest") {
            nav(`/edit-profile/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "direct") {
            if (e?.linkUrl) {
                window.open(e.linkUrl, "_blank", "noopener,noreferrer");
            }
        } else if (e?.notificationType === "post" || e?.notificationType === "comment" ||
            e?.notificationType.toLowerCase() === "goal" || e?.notificationType === "like") {
            nav(`/community/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "freesources") {
            nav(`/free-sources/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "communitygroup") {
            nav(`/community-groups/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "Assign Pathway") {
            nav(`/learning-paths/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "coursecomplete" || e?.notificationType === "course" || e?.notificationType === "courseupdate" ||
            e?.notificationType === "coursestart" || e?.notificationType === "sendassigncoursetouser" || e?.notificationType === "sendassignedcourseinstructore") {
            nav(`/ceu-courses/${e?.relatedId}`, { replace: true });
        } else if (e?.notificationType === "Pathway Approval Request") {
            nav(`/dashboard/notifications`, { replace: true });
        }
        handleClose();
    };

    const handleRead = async () => {
        let apiUrl = {
            url: `/api/Common/UpdateNotificationByUserId?userId=${LoginUserd.userId}`,
        };
        let resp = await PostCallApi(apiUrl);
        if (resp?.status === 200) {
            if (resp?.data?.success) {
                getNotification();
                handleClose();
            }
        }
    };
    const handleSideNav = () => {
        setIsSidebarChatOpen(false)
        setIsOpen(!isOpen)
    }

    const [openMainMenus, setOpenMainMenus] = useState({ Reports: false, Settings: false });
    const [openSubmenus, setOpenSubmenus] = useState({ Reports: '', Settings: '' });

    const toggleMainMenu = (menuName) => {
        const sendMenu = menuName === "Reports" ? { Settings: false } : { Reports: false };
        setOpenMainMenus((prev) => ({
            ...sendMenu,
            [menuName]: !prev[menuName]
        }));
        setOpenSubmenus((prev) => ({
            ...prev,
            [menuName]: ''
        }));
    };

    const toggleSubMenu = (mainMenu, submenu) => {
        setOpenSubmenus((prev) => ({
            ...prev,
            [mainMenu]: prev[mainMenu] === submenu ? '' : submenu
        }));
    };

    const handleSubmenu = (e, menu) => {
        if (menu?.menuName === "Settings" || menu?.menuName === "Reports") {
            e.preventDefault();
            toggleMainMenu(menu?.menuName);
        } else {
            setIsOpen(false)
        }
    };

    const innerSubMenu = (e, item, mainMenu) => {
        e.preventDefault();

        if (item?.subMenu) {
            toggleSubMenu(mainMenu, item.menuName);
        } else {
            if (item?.menuType === "ReportMenuInnerMenu") {
                if (pathname !== '/reports' || !includes(pathname, '/reports')) {
                    nav('/reports', { replace: true });
                }
                dispatch(ReportName(item?.menuName));
            } else {
                // Navigate to the item's own route, not bare /settings. Going to /settings
                // tripped the effect in Setting.jsx that clears MenuName whenever the path is
                // exactly /settings, so every sidebar click used to bounce back to the hub.
                const target = `/settings/${item?.menuUrl}`;
                dispatch(SettingName(item?.menuName));
                dispatch(SettingNameUrl(target));
                dispatch(CreteDataFor(false));
                nav(target, { replace: true });
            }
        }
    };

    const renderSubMenu = (submenus = [], mainMenu, classNa) => (
        <>
            <ul className={`${submenus ? "open" : ""} ${classNa}`}>
                {submenus.map((item, idx) => (
                    <li key={idx} className={`submenu-menu-item ${openSubmenus[mainMenu] === item.menuName ? 'open' : ''}`}>
                        <Link
                            className="submenu_header_link"
                            to={item.menuUrl || "#"}
                            onClick={(e) => innerSubMenu(e, item, mainMenu)}
                        >
                            {item.displayName || item.menuName}
                            {item?.subMenu && (
                                <IoIosArrowUp className={`icon ${openSubmenus[mainMenu] === item.menuName ? 'open' : ''}`} />
                            )}
                        </Link>
                        {item?.subMenu && openSubmenus[mainMenu] === item.menuName && renderSubMenu(item.subMenu, mainMenu, classNa = 'inner-submenu')}
                    </li>
                ))}
            </ul>
        </>
    );


    return (
        <>
            <div>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={openCircle}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
                    <button onClick={() => handleSideNav()} className="toggle-btn">
                        {isOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
                    </button>
                    <div className="manu-wrapper">
                        <Link to="/dashboard" className="main_logo">
                            <img
                                src={header_logo}
                                className="header_logo"
                                alt="header_logo"
                            />
                        </Link>
                        <div className="controlicons">
                            <ul>
                                <li>
                                    <Tooltip
                                        title="FIG User Manual"
                                        placement="top"
                                        arrow
                                        className="tooltip_manage"
                                    >
                                        <div>
                                            <Link
                                                to={`${Config.API_HOST_URL_live}/Manuals/employee_role_user_manual.pdf`}
                                                className="header_search_button "
                                                // className="header_search_button btn"
                                                target="_blank"
                                            // download
                                            >
                                                <img
                                                    src={user_mennul}
                                                    className="img-fluid"
                                                    alt=""
                                                    width={24}
                                                    height={24}
                                                />
                                            </Link>
                                        </div>
                                    </Tooltip>
                                </li>
                                <li>
                                    <Tooltip
                                        title="Help"
                                        placement="top-start"
                                        arrow
                                        className="tooltip_manage "
                                    >
                                        <div>
                                            <Link
                                                to={"/help"}
                                                className="header_search_button "
                                            // onClick={handleHelp}
                                            >
                                                <img src={information} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                    </Tooltip>
                                </li>
                                <li>
                                    <Tooltip
                                        title="Message"
                                        placement="top-start"
                                        arrow
                                        className="tooltip_manage "
                                    >
                                        <div>
                                            <Link
                                                to={"/messages"}
                                                className="header_search_button "
                                            // onClick={handleMessage}
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g clipPath="url(#clip0_6_815)">
                                                        <path
                                                            d="M23 11.3889C23.0042 13.0021 22.6273 14.5934 21.9 16.0333C21.0376 17.7588 19.7119 19.2101 18.0713 20.2247C16.4307 21.2393 14.5401 21.777 12.6111 21.7778C10.9979 21.782 9.40657 21.4051 7.96666 20.6778L1 23L3.32222 16.0333C2.59491 14.5934 2.21801 13.0021 2.22222 11.3889C2.22297 9.45995 2.76075 7.56929 3.77532 5.9287C4.78989 4.28811 6.24119 2.96239 7.96666 2.10003C9.40657 1.37273 10.9979 0.995829 12.6111 1.00003H13.2222C15.7697 1.14058 18.1759 2.21585 19.98 4.01997C21.7841 5.82409 22.8594 8.23027 23 10.7778V11.3889Z"
                                                            stroke="#2C2E35"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <circle cx="8" cy="12" r="1" fill="#2C2E35" />
                                                        <circle cx="12" cy="12" r="1" fill="#2C2E35" />
                                                        <circle cx="16" cy="12" r="1" fill="#2C2E35" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_6_815">
                                                            <rect width="24" height="24" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </Link>
                                        </div>
                                    </Tooltip>
                                </li>
                                <li>
                                    <Tooltip
                                        title="Notification"
                                        placement="top-start"
                                        arrow
                                        className="tooltip_manage last"
                                    >
                                        <div>
                                            <Button
                                                className="header_search_button"
                                                onClick={handleClick}
                                                sx={{ minWidth: "max-content", padding: "0px" }}
                                            >
                                                <Badge
                                                    sx={{
                                                        ".MuiBadge-badge": {
                                                            color: "#fff",
                                                            background: "linear-gradient(90deg, #1ebec8 -7.19%, #86c65a 105.94%)",
                                                        }
                                                    }}
                                                    className="badgeNotfication"
                                                    badgeContent={
                                                        notificationList?.length > 0
                                                            ? notificationList?.filter(
                                                                (x) => x?.isRead === false
                                                            )?.length
                                                            : 0
                                                    }
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
                                                            stroke="#2C2E35"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
                                                            stroke="#2C2E35"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </Badge>
                                            </Button>
                                        </div>
                                    </Tooltip>
                                </li>
                            </ul>
                        </div>
                        <ul className="menu">
                            {sidebarMenus?.filter((x) => x.old !== true)?.map((menu, i) => (
                                <li
                                    className={`menu-item ${pathname === menu?.menuUrl ? "active" : ""}`}
                                    key={i}
                                >
                                    <Link
                                        className="header_link"
                                        // Market points at the district's own store when it has
                                        // one; every other menuUrl passes through untouched.
                                        to={resolveMarketUrl(menu?.menuUrl)}
                                        onClick={(e) => handleSubmenu(e, menu)}
                                    >
                                        <span>{menu?.menuName}</span>
                                        {(menu?.menuName === "Settings" || menu?.menuName === "Reports") && (
                                            <IoIosArrowUp className={`icon ${openMainMenus[menu?.menuName] ? 'open' : ''}`} />
                                        )}
                                    </Link>
                                    {(menu?.menuName === "Settings" || menu?.menuName === "Reports") && openMainMenus[menu?.menuName] && (
                                        renderSubMenu(menu?.menuName === "Reports" ? (ReportList || []) : settingsSubMenu, menu?.menuName, 'submenu')
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className="profileInfo">
                            {pathname === "/dashboard" &&
                                <div className="dashboard_switch">
                                    <Tooltip
                                        title={`Switch to ${isModern ? "modern" : "classic"} dashboard`}
                                        placement="top"
                                        arrow
                                        className="tooltip_manage"
                                    >
                                        <label className="dashboard_toggle_switch">
                                            <span className={`switch-wrapper`}>
                                                <input
                                                    type="checkbox"
                                                    checked={isModern}
                                                    onChange={toggleDashboard}
                                                />
                                                <span className={`${isModern ? "btn-success" : "btn-danger"} switch`}>
                                                    <span className="switch-handle" />
                                                </span>
                                            </span>
                                        </label>
                                    </Tooltip>
                                </div>
                            }
                            <Dropdown className="drop_down">
                                <Dropdown.Toggle className="header_option overflow-hidden">
                                    <img
                                        src={
                                            LoginUserd?.thumbnailProfileUrl === "" ||
                                                LoginUserd?.thumbnailProfileUrl === null
                                                ? pro_img
                                                : `${Config.API_HOST_URL_live}${LoginUserd?.thumbnailProfileUrl}`
                                        }
                                        alt="profile"
                                        className="user_profile"
                                    />
                                    <p className="name">
                                        {LoginUserd?.firstName + " " + LoginUserd?.lastName}
                                    </p>
                                    <FaAngleRight />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <di className="w-100 ">
                                        <div
                                            className="profile_info"
                                            style={{ marginLeft: "10px", padding: "0 8px" }}
                                        >
                                            <span className={`header_login_icon `}>
                                                {LoginUserd?.firstName + " " + LoginUserd?.lastName}
                                            </span>
                                            <span
                                                className={`header_login_icon p_14_text role d-block`}
                                                style={{ color: " #36454F" }}
                                            >
                                                {LoginUserd?.roleName}
                                            </span>
                                            <span
                                                className="header_login_icon p_14_text district_name d-block"
                                                style={{ color: " #36454F" }}
                                            >
                                                {LoginUserd?.schooldistrictName}
                                            </span>
                                        </div>
                                    </di>
                                    <Dropdown.Divider />
                                    <IconButton className="w-100 logout_bnt">
                                        <Link
                                            className="header_user_Link w-100 d-flex justify-content-start"
                                            to="/edit-profile"
                                        >
                                            <span className="header_user_link_text1">
                                                Profile
                                            </span>
                                        </Link>
                                    </IconButton>
                                    <Dropdown.Divider />
                                    <IconButton className="w-100 logout_bnt">
                                        <Link
                                            className="header_user_Link w-100 d-flex justify-content-start"
                                            to="/email-preference"
                                        >
                                            <span className="header_user_link_text1">
                                                Email Preference
                                            </span>
                                        </Link>
                                    </IconButton>
                                    <Dropdown.Divider />
                                    <IconButton className="w-100 logout_bnt">
                                        <Link
                                            className="header_user_Link w-100 d-flex justify-content-start"
                                            to="/logged-reset-password"
                                        >
                                            <span className="header_user_link_text1">
                                                Reset Password
                                            </span>
                                        </Link>
                                    </IconButton>
                                    <Dropdown.Divider />
                                    <IconButton
                                        onClick={() => handleNav()}
                                        className="w-100 logout_bnt"
                                    >
                                        <span className="header_user_link_text2">Logout</span>
                                    </IconButton>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <Menu
                className="notification_list"
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={openNotification}
                onClose={handleClose}
            >
                {notificationList?.map((notifi, i) => {
                    return (
                        <MenuItem
                            className={`${notifi?.isRead ? "noShow_colors" : "show_color"}`}
                            key={i}
                            onClick={() => HandleNotificationRedirect(notifi)}
                        >
                            <div className="notification_box">
                                <div className="img_box me-3">
                                    <img src={notifi?.imgUser} alt="" />
                                </div>
                                <div className="notification_msg">
                                    <div className="p_16_text">{notifi?.user}</div>
                                    <div className="p_14_text">{notifi?.notificationText}</div>
                                </div>
                            </div>
                        </MenuItem>
                    );
                })}
                {notificationList?.filter((x) => x?.isRead === false)?.length > 0 ? (
                    <div style={{ display: "flex", justifyContent: "space-between", position: "sticky", bottom: 0 }}>
                        <div className="mark_as_read">
                            <Link onClick={handleRead}>Mark all as read</Link>
                        </div>
                        <div className="mark_as_read">
                            <Link to="/dashboard/notifications" onClick={handleClose}>View all Notifications</Link>
                        </div>
                    </div>
                ) : (
                    <div style={{ display: "flex", justifyContent: "space-between", position: "sticky", bottom: 0 }}>
                        <div className="mark_as_read">
                            <Link onClick={handleClose}>Mark all as read</Link>
                        </div>
                        <div className="mark_as_read">
                            <Link to="/dashboard/notifications" onClick={handleClose}>View all Notifications</Link>
                        </div>
                    </div>
                )}
                {/* {notificationList?.filter((x) => x?.isRead === false)?.length > 0 ? (
                    <div className="mark_as_read">
                        <Link onClick={handleRead}>Mark all as read</Link>
                    </div>
                ) : (
                    <div className="mark_as_read">
                        <Link onClick={handleClose}>Mark all as read</Link>
                    </div>
                )} */}
            </Menu>
        </>
    )
}

export default SidebarMenu;
